<template>
  <div class="error-wrap">
    <div class="error-content">
      <img class="tip-img" src="../assets/images/device_limit.png" alt="">
      <p>网站当前在线设备数已超出限制</p>
      <el-button class="mt12 go-back" type="primary" @click="goBack">重新访问</el-button>
    </div>
  </div>
</template>

<script>
import "../assets/css/common.css"
export default {
  name: "bigScreenError",
  mounted(){
    document.getElementById("loading_bg_preview").style.display = "none"
  },
  methods:{
    goBack(){
      const historyHref = sessionStorage.getItem("historyHref")
      if(historyHref){
        window.location.href = historyHref
      }
    }
  }
}
</script>

<style scoped>

.error-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #1F2124;
  text-align: center;
}
.error-content{
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
}
.tip-img {
  width: 372px;
  height: 278px;
  margin-bottom: 20px;
}

.error-wrap p {
  color: rgba(255, 255, 255, 0.80);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}
.go-back{
  color: #fff;
  background-color: #1770FF !important;
}
.go-back:hover{
  background-color: rgba(23, 112, 255, 0.8) !important;
}
</style>